export const NO_PROCESSED_ELEMENTS = 1;
export const MAX_RETRIES = 0;
export const STATUS_CANNOT_BE_CHANGED = 'STATUS_CANNOT_BE_CHANGED';
